import { render, staticRenderFns } from "./InspectionRefStandardized.vue?vue&type=template&id=4ed8496e&scoped=true"
import script from "./InspectionRefStandardized.vue?vue&type=script&lang=js"
export * from "./InspectionRefStandardized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed8496e",
  null
  
)

export default component.exports